module.exports = {
      id: "login-google-usage",
      viewBox: "0 0 52.573 52.573",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#login-google",
      toString: function () {
        return this.url;
      }
    }